




































































import { Vue, Prop } from 'vue-property-decorator';
import { Component } from 'vue-property-decorator';
import { Auth } from '@/kuroco_api/core/Auth';
import { UserStateModule } from '../../store';
import { OpenAPI } from '../../kuroco_api';

@Component<Login>({})
export default class Login extends Vue {
  // FIELDS
  input = {
    email: '',
    password: '',
  };

  // METHODS
  samlLogin(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    function createNodeWithAttributes(tagName: string, attributes: { nm: string; val: string }[] = []) {
      const node = document.createElement(tagName);
      attributes.forEach(({ nm, val }) => node.setAttribute(nm, val));
      return node;
    }

    const form = createNodeWithAttributes('form', [
      { nm: 'id', val: 'google_login_saml' },
      { nm: 'action', val: OpenAPI.SAML_URL },
      { nm: 'method', val: 'POST' },
    ]);
    const input = createNodeWithAttributes('input', [
      { nm: 'type', val: 'hidden' },
      { nm: 'name', val: 'api_id' },
      { nm: 'value', val: '1' },
    ]);

    form.appendChild(input);

    (document.querySelector('body') as HTMLBodyElement).appendChild(form);
    (document.querySelector('#google_login_saml') as HTMLFormElement).submit();
  }
  async submit(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    await Auth.login({ requestBody: { ...this.input } })
      .then((member_id) => UserStateModule.initialize({ member_id: member_id as number }))
      .catch((e) => {
        (this as any).$snack.danger({ text: 'ログインできませんでした。', button: 'OK' });
        console.error(e);
        return Promise.reject(e);
      });
    this.$router.push({ path: '/' });
  }
}
